export const outer = "outer-circle";
export const inner = "inner-circle";
export const clickable = "clickable-circle";
export const source = "points";